import z from "zod";
/**
 * PatrimonioCentroCustoSchema
 */

export const PatrimonioCentroCustoSchema = z.object({
  idPatrimonioCentroCusto: z.number().optional(),
  idCentroCusto: z.coerce.number().nullable().optional(),
  status: z.coerce.number().default(1),
});

/**
 * PatrimonioCentroCustoForm
 */

export type PatrimonioCentroCustoForm = z.infer<typeof PatrimonioCentroCustoSchema>;

/**
 * initialPatrimonioCentroCustoForm
 */

export const initialPatrimonioCentroCustoForm: Partial<PatrimonioCentroCustoForm> = {
  status: 0,

};